import {
  type ISocketOrderEvent,
  type TSocketOrderEventKey
} from '@/types/ISocketOrderEvent';
import { type IOrder } from '@/types/IOrder';
import { isRecord } from './isRecord';

const KNOWN_EVENT_KEYS: ReadonlySet<string> = new Set(['order_post_persist']);

const isKnownEventKey = (value: unknown): value is TSocketOrderEventKey =>
  typeof value === 'string' && KNOWN_EVENT_KEYS.has(value);

/**
 * Проверяет, что объект похож на заказ (IOrder) по ключевым полям.
 * Глубокую валидацию IOrder намеренно не делаем — сверяем только то,
 * по чему дальше работает логика вставки и упорядочивания.
 */
const isOrderLike = (value: unknown): value is IOrder =>
  isRecord(value) &&
  typeof value.id === 'number' &&
  typeof value.uuid === 'string';

/**
 * Type guard формы события заказа из Mercure. Сверяет обязательные поля
 * обёртки и форму `data` (как заказ). Используется при парсинге SSE-потока и
 * при чтении персистнутой истории уведомлений из localStorage.
 *
 * @param value - произвольное значение (распарсенный JSON)
 * @returns `true`, если значение соответствует форме `ISocketOrderEvent`
 */
export const isSocketOrderEvent = (
  value: unknown
): value is ISocketOrderEvent =>
  isRecord(value) &&
  isKnownEventKey(value.event) &&
  typeof value.status === 'string' &&
  typeof value.datetime === 'number' &&
  isOrderLike(value.data);
